import {
  Box,
  Button,
  Divider,
  Flex,
  HStack,
  Image,
  Text,
  Textarea,
} from "@chakra-ui/react";
import smrImage5 from "@/assets/images/smr_img5.png";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { RiShuffleFill, RiSparkling2Fill } from "@remixicon/react";
import { selectMode, updateDesign } from "@/reducer/modeslice";

const SmrDescription = () => {
  const dispatch = useAppDispatch();
  const { design } = useAppSelector(selectMode);



  const handleChangeDescription = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const newValue = e.target.value;
    const newdesign = { ...design, prompt: newValue };
    dispatch(updateDesign(newdesign));
  };

  const handleCleanDes = () => {
    const newdesign = { ...design, prompt: "" };
    dispatch(updateDesign(newdesign));
  }

  return (
    <Box
      background="linear-gradient(40.59deg, #496AE1 72.71%, #172147 86.65%)"
      borderRadius="10px"
      p="1px"
      mt="20px"
    >
      <Box
        p="20px"
        borderRadius="10px"
        background="linear-gradient(237.85deg, #172248 9.18%, #161922 67.26%)"
      >
        <HStack>
          <Image src={smrImage5} />
          <Text fontSize={"16px"} color="#FFFFFF">
            创意描述
          </Text>
          <Text fontSize={"12px"} color={"#6C7596"}>
            （非必填）
          </Text>
        </HStack>
        <Box mt="15px" bg="#0C0B10" borderRadius={"10px"} p="12px">
          <Textarea
            placeholder="请输入创意描述，包含内容主体、风格，颜色、细节描述、形容修饰等"
            borderRadius={0}
            bgColor="none"
            border={"none"}
            fontSize="14px"
            color={"#fff"}
            maxLength={500}
            value={design.prompt}
            onChange={handleChangeDescription}
          />
          <Flex mt="10px" justifyContent={"space-between"} alignItems="center">
            <HStack spacing={"10px"}>
              {/* <Button
                // w="83px"
                h="25px"
                bg="#1E253F"
                color={"#FFFFFF"}
                fontSize="11px"
                fontWeight={"normal"}
                borderRadius={"25px"}
                _hover={{
                  bg: "#303853",
                }}
              >
                <RiSparkling2Fill color="#FFFFFF" size="10px" />
                AI生成创意
              </Button>
              <Button
                // w="83px"
                h="25px"
                bg="#1E253F"
                color={"#FFFFFF"}
                fontSize="11px"
                fontWeight={"normal"}
                borderRadius={"25px"}
                _hover={{
                  bg: "#303853",
                }}
              >
                <RiShuffleFill color="#FFFFFF" size="10px" />
                随机
              </Button> */}
            </HStack>
            <HStack spacing={"10px"}>
              <Text fontSize={"13px"} color={"#6C7596"}>
                {design.prompt?.length || 0}/500
              </Text>
              <Divider orientation="vertical" h="10px" color={"#6C7596"} />
              <Text
                fontSize={"13px"}
                color={"#6C7596"}
                cursor="pointer"
                _hover={{ color: "#fff" }}
                onClick={handleCleanDes}
              >
                清空
              </Text>
            </HStack>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

export default SmrDescription;
